import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import LoadingAnimation from '../partials/LoadingAnimation';
import animationData from '../utils/2024-07-05_MoT_Intro_Desktop.json'; // Adjust path as needed
import animationDataMobile from '../utils/2024-07-11_MoT_Intro_Mobile.json'; // Adjust path as needed

const Layout = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if the loading animation has been shown before
    const hasSeenAnimation = localStorage.getItem('hasSeenAnimation');

    if (!hasSeenAnimation) {
      // Show the loading animation if it hasn't been shown before
      setIsLoading(true);
      localStorage.setItem('hasSeenAnimation', 'true');

      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 4500); // Duration of the loading animation in milliseconds

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    // Function to clear the local storage flag on page unload
    const handleUnload = () => {
      localStorage.removeItem('hasSeenAnimation');
    };

    // Add the event listener for beforeunload
    window.addEventListener('beforeunload', handleUnload);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  return (
    <div className="layout-container">
      {isLoading ? (
          <LoadingAnimation animationData={animationData} animationDataMobile={animationDataMobile} />
      ) : (
        <motion.main
          className="movers-of-tomorrow"
          initial={{ backgroundColor: 'bg-purple', opacity: 0 }}
          animate={{ backgroundColor: 'bg-black', opacity: 1}}
          transition={{ type: 'spring' }}
        >
          {children}
        </motion.main>
      )}
    </div>
  );
};

export default Layout;
